import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import Icon from '../../assets/Icon';
import history from '../../providers/history';
import { Container } from './styles';

const BackButton: React.FC = () => {
    const theme = useContext(ThemeContext);

    return <Container onClick={() => {
        history.back();
    }}>
        <Icon icon={'back-arrow'} size={24} color={theme.colors.primaryText} />  Voltar
    </Container>
}

export default BackButton;